/*
  SOPHIOR contactformulier — zichtbare validatiefouten (P-23).

  Het formulier hield zijn native required/type-validatie; die toonde alleen een
  browserbubbel en zette geen aria-invalid. Dit script onderdrukt de bubbel en
  toont in plaats daarvan de melding die in de sectie-instellingen staat, met
  aria-invalid op het veld zelf. Verstuurt niets: de browser blokkeert het
  versturen al zolang een verplicht veld leeg of ongeldig is. Zonder JS blijft
  de browserbubbel gewoon werken.
*/
(function () {
  'use strict';

  var FORM_SELECTOR = '.sophior-contact__form';
  var FIELD_SELECTOR = '.sophior-contact__field';
  var ERROR_SELECTOR = '.sophior-contact__field-error';
  var INVALID_CLASS = 'sophior-contact__field--invalid';

  function errorElement(input) {
    var field = input.closest(FIELD_SELECTOR);
    if (!field) return null;
    return field.querySelector(ERROR_SELECTOR);
  }

  function messageFor(input, errorEl) {
    if (input.validity.typeMismatch && errorEl.dataset.errorTypeMismatch) {
      return errorEl.dataset.errorTypeMismatch;
    }
    return errorEl.dataset.errorDefault || '';
  }

  function showError(input) {
    var errorEl = errorElement(input);
    if (!errorEl) return;
    errorEl.textContent = messageFor(input, errorEl);
    errorEl.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.closest(FIELD_SELECTOR).classList.add(INVALID_CLASS);
  }

  function clearError(input) {
    var errorEl = errorElement(input);
    if (!errorEl) return;
    errorEl.hidden = true;
    input.removeAttribute('aria-invalid');
    input.closest(FIELD_SELECTOR).classList.remove(INVALID_CLASS);
  }

  function bind(form) {
    if (form.dataset.sophiorValidated === 'true') return;
    form.dataset.sophiorValidated = 'true';

    var inputs = form.querySelectorAll('input[required], textarea[required]');

    Array.prototype.forEach.call(inputs, function (input) {
      // De browser valideert bij verzenden, focust zelf het eerste foute veld
      // en toont dan normaal een bubbel. preventDefault haalt alleen de bubbel
      // weg; het verzenden blijft geblokkeerd.
      input.addEventListener('invalid', function (event) {
        event.preventDefault();
        showError(input);
      });

      // Tijdens het typen alleen opruimen, nooit alvast afkeuren.
      input.addEventListener('input', function () {
        if (input.validity.valid) clearError(input);
      });

      // Bij verlaten van het veld pas afkeuren als er iets is ingevuld.
      input.addEventListener('blur', function () {
        if (input.validity.valid) {
          clearError(input);
        } else if (input.value.trim() !== '') {
          showError(input);
        }
      });
    });
  }

  function init(root) {
    var forms = (root || document).querySelectorAll(FORM_SELECTOR);
    Array.prototype.forEach.call(forms, bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: opnieuw binden nadat de sectie is herladen.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
